import React from '@root/vendor/react';

const EmailContext = React.createContext();

export default EmailContext;
